import React, { useState, useEffect } from "react";
import EN from "../../assets/images/langEn.png";
import TH from "../../assets/images/langTh.png";
import "../../assets/styles/components/header.scss";
import { Button } from "antd";
import { i18n } from '../../i18n/i18n';
import queryString from "query-string";
import { useHistory, useLocation } from "react-router-dom";
import { namespaces, languages } from '../../i18n/i18n.constants';


interface Props {
  noHeader?: boolean;
  firstPage?: boolean;
  btnBack?: boolean;
  onClick?: () => void;
  title?: string;
  children?: object;
}


interface UserItem {
  email: string;
  gender: string;
  name: {
    first: string;
    last: string;
    title: string;
  };
  nat: string;
  picture: {
    large: string;
    medium: string;
    thumbnail: string;
  };
}

const ContainerHeight = 400;
const HeaderBar: React.FC<Props> = ({
  noHeader = false,
  btnBack = false,
  title = "",
  children,
  onClick
}) => {
  const { search } = useLocation();
  const query: any = queryString.parse(search);
  if (
    query?.from !== undefined || query?.reques !== undefined || query?.customerid !== undefined
  ) {
    localStorage.setItem("param_from", query?.from);
    localStorage.setItem("param_reques", query?.reques);
    localStorage.setItem("param_customer", query?.customerid);
    localStorage.setItem("param_token", query?.token);

    if (query?.identifier !== undefined || query?.ndid_phase !== undefined){
      localStorage.setItem("param_identifier", query?.identifier);
      localStorage.setItem("param_ndid_phase", query?.ndid_phase);
    }

  }
  const paramFrom = localStorage.getItem("param_from");
  const paramReques = localStorage.getItem("param_reques");
  const param_customer = localStorage.getItem("param_customer");
  const param_token = localStorage.getItem("param_token");
  const history = useHistory();

  return (
    <div className="header-bar">
      {console.log('header param', paramFrom)}
      {console.log('query?.from', query?.from)}

      {param_customer === undefined ? (
        (param_token !== undefined) ? (
          <a onClick={() => history.push(`/home?from=${paramFrom}&reques=${paramReques}`)}>
          {paramFrom === "daolinv" ? (<img src="https://ktbst-daolgroup-staticsite.s3.ap-southeast-1.amazonaws.com/daol-invest.png" alt="DAOL INVESTMENT" />) :
            paramFrom === "daolsec" ?
              (<img src="https://ktbst-daolgroup-staticsite.s3.ap-southeast-1.amazonaws.com/daol-sec.png" alt="DAOL SEC" />)
              : (<img src="https://ktbst-daolgroup-staticsite.s3.ap-southeast-1.amazonaws.com/daol-sec.png" alt="DAOL SEC" />)}
          </a>  
        ):(
          <a onClick={() => history.push(`/home?from=${paramFrom}&reques=${paramReques}&reques=${param_token}`)}>
          {paramFrom === "daolinv" ? (<img src="https://ktbst-daolgroup-staticsite.s3.ap-southeast-1.amazonaws.com/daol-invest.png" alt="DAOL INVESTMENT" />) :
            paramFrom === "daolsec" ?
              (<img src="https://ktbst-daolgroup-staticsite.s3.ap-southeast-1.amazonaws.com/daol-sec.png" alt="DAOL SEC" />)
              : (<img src="https://ktbst-daolgroup-staticsite.s3.ap-southeast-1.amazonaws.com/daol-sec.png" alt="DAOL SEC" />)}
          </a>  
        )
      ) : (
        <a onClick={() => history.push(`/home?from=${paramFrom}&reques=${paramReques}&customerid=${param_customer}`)}>
          {paramFrom === "daolinv" ? (<img src="https://ktbst-daolgroup-staticsite.s3.ap-southeast-1.amazonaws.com/daol-invest.png" alt="DAOL INVESTMENT" />) :
            paramFrom === "daolsec" ?
              (<img src="https://ktbst-daolgroup-staticsite.s3.ap-southeast-1.amazonaws.com/daol-sec.png" alt="DAOL SEC" />)
              : (<img src="https://ktbst-daolgroup-staticsite.s3.ap-southeast-1.amazonaws.com/daol-sec.png" alt="DAOL SEC" />)}
        </a>
      )}

      {paramFrom === "daolsec" ?
        <div className="box-lang">
          {(i18n.language === "th") ? (
            <Button type="text" className="btn-lang" onClick={() => i18n.changeLanguage('en')}>
              <img src={EN} alt="EN" />
            </Button>
          ) :
            (<Button type="text" className="btn-lang" onClick={() => i18n.changeLanguage('th')}>
              <img src={TH} alt="TH" />
            </Button>)
          }
        </div> : ""}

    </div >
  );
};
export default HeaderBar;
